import React from 'react'
import { FormattedMessage } from 'react-intl'
import Modal from 'modals/dialog'
import { Columns } from './s'
import { Big as Heading } from 'modals/dialog/s'
import Paragraph from 'components/typography/paragraph'
import DisplaySymbol from 'components/symbol'

const Hero = ({ label, symbol }) => (
    <Modal.Header showDismiss={false}>
        <Columns>
            <div>
                {!!label && <Paragraph className="caption compact">{label}</Paragraph>}
                <Heading>
                    <FormattedMessage
                        id="symbol_action_pick"
                        defaultMessage="Pick symbol" />
                </Heading>
            </div>
            <DisplaySymbol symbol={symbol} />
        </Columns>
    </Modal.Header>
)

export default Hero